import { ProfileCustomFieldService } from '../../shared/profile-custom-field.service';
import { ProfileCustomField } from '../../shared/model/profile-custom-field.model';
import { CustomFieldService } from '../../shared/custom-field.service';
import { Component, OnChanges, Input } from '@angular/core';
import { CustomFieldDto } from '../../shared/dto/custom-field.dto';
import { ObjectStateEnum } from 'src/app/shared/model';

@Component({
  selector: 'wl-profile-edit-custom-fields',
  templateUrl: './profile-edit-custom-fields.component.html',
  styleUrls: ['./profile-edit-custom-fields.component.less'],
  providers: [CustomFieldService],
    standalone: false
})
export class ProfileEditCustomFieldsComponent implements OnChanges {
  @Input() profileId: number;
  public customFields: CustomFieldDto[];
  public hiddenCustomFields: CustomFieldDto[];
  public profileCustomFields: ProfileCustomField[];

  private _profileCustomFieldIdsToDelete: number[];
  constructor(private _customFieldService: CustomFieldService, private _profileCustomFieldService: ProfileCustomFieldService) {
    this.customFields = [];
    this.profileCustomFields = [];
    this.hiddenCustomFields = [];
    this._profileCustomFieldIdsToDelete = [];
  }

  ngOnChanges() {
    if (this.profileId) {
      this.loadData();
    }
  }

  set selectedCustomField(value: CustomFieldDto) {
    if (this.customFields.length > 0) {
      const index = this.customFields.findIndex((x) => x.CustomFieldID === value.CustomFieldID);
      this.customFields.splice(index, 1);
      this.customFields = this.copy(this.customFields);
      this.hiddenCustomFields.push(value);

      const profileCustomField = new ProfileCustomField();
      profileCustomField.ProfileId = this.profileId;
      profileCustomField.CustomFieldId = value.CustomFieldID;
      profileCustomField.FieldName = value.Name;
      this.profileCustomFields.push(profileCustomField);
    }
  }

  deleteField(index: number) {
    if (this.profileCustomFields[index].Id) {
      this._profileCustomFieldIdsToDelete.push(this.profileCustomFields[index].Id);
    }
    const deletedProfileField = this.profileCustomFields[index];
    const hiddenCustomFieldIndex = this.hiddenCustomFields.findIndex((x) => x.CustomFieldID === deletedProfileField.CustomFieldId);
    this.customFields.push(this.hiddenCustomFields[hiddenCustomFieldIndex]);
    this.customFields = this.copy(this.customFields);
    this.profileCustomFields.splice(index, 1);
    this.hiddenCustomFields.splice(hiddenCustomFieldIndex, 1);
  }

  save() {
    const promises: Promise<void>[] = [];
    this.profileCustomFields.forEach((customField) => {
      const fieldType = [...this.hiddenCustomFields, ...this.customFields].find(
        (x) => x.CustomFieldID === customField.CustomFieldId
      )?.DataType;
      if (fieldType === 'Date') {
        customField.FieldValue = new Date(customField.FieldValue).toLocaleDateString();
      }
      if (!customField.Id) {
        promises.push(
          this._profileCustomFieldService.createProfileCustomField(this.profileId, customField).then((id) => {
            customField.Id = id;
          })
        );
      } else if (customField.ObjectState === ObjectStateEnum.Modified) {
        promises.push(this._profileCustomFieldService.updateProfileCustomField(this.profileId, customField));
      }
    });
    this._profileCustomFieldIdsToDelete.forEach((id) => {
      promises.push(this._profileCustomFieldService.deleteProfileCustomField(this.profileId, id));
    });
    return Promise.all(promises).then(() => {
      this.profileCustomFields.forEach((f) => {
        f.ObjectState = ObjectStateEnum.Unchanged;
      });
    });
  }

  private loadData() {
    this._customFieldService.searchCustomFields().then((data) => {
      this.customFields = data.Result;
      this._profileCustomFieldService.getProfileCustomFieldsForProfileId(this.profileId).then((profileFields) => {
        this.profileCustomFields = profileFields;
        this.hiddenCustomFields = this.customFields.filter((x) => profileFields.some((y) => y.CustomFieldId === x.CustomFieldID));
        this.customFields = this.customFields.filter((x) => !profileFields.some((y) => y.CustomFieldId === x.CustomFieldID));
      });
    });
  }

  private copy(object: any) {
    return JSON.parse(JSON.stringify(object));
  }
}
